import { useQuery } from '@tanstack/react-query';
import ApiService from '../../ApiService';

const fetchData = async () => {
    const { data } = await ApiService.getDspInventorySourceExchanges();
    return data;
};

const useDspInventorySourceExchangeListQuery = () => {
    return useQuery({
        queryKey: ['dspInventorySourceExchangeList'],
        queryFn: () => fetchData(),
        staleTime: Infinity,
        enabled: false,
    });
};

export { useDspInventorySourceExchangeListQuery };
